export const SOURCE = 'source';
export const MEDIUM = 'medium';
export const CAMPAIGN = 'campaign';
export const TERM = 'term';
export const CONTENT = 'content';
export const GTM_SOURCE = 'utmcsr';
export const GTM_MEDIUM = 'utmcmd';
export const GTM_CAMPAIGN = 'utmccn';
export const GTM_CONTENT = 'utmcct';
export const GTM_TERM = 'utmctr';
export const UTM_SOURCE = 'utmcsr';
export const UTM_MEDIUM = 'utmcmd';
export const UTM_CAMPAIGN = 'utmccn';
export const UTM_CONTENT = 'utmcct';
export const UTM_TERM = 'utmctr';
export const GCLID = 'utmgclid';
export const DCLID = 'utmdclid';
export const IAID = 'iaid';
export const DIRECT = '(direct)';
export const NOTSET = '(not set)';
export const NOTPROVIDED = '(not provided)';
export const UTMZ = '__utmz';
export const UTMZZ = '__utmzz';
export const UTMZZSES = '__utmzzses';
export const DEFAULT_INSTANCE = 'default_instance';
export const GOOGLE = 'google';
export const YAHOO = 'yahoo';
export const ORGANIC = 'organic';
export const REFERRAL = 'referral';
export const CPC = 'cpc';
export const CPM = 'cpm';
export const WWW = 'www.';
export const EMPTY_STRING = '';
export const CMCMARKETS_URL = 'cmcmarkets.com';
